export const pathname = (value) => {
    const url = new URL(value);
    return url.pathname;
};
